import { ActionItem } from '../components/StepActions';
import { getShareButtonText, getStepShareMeta } from '../config/stepShareConfig';

export function canShareStepWork(
  stepNumber: number,
  actions: Pick<ActionItem, 'id' | 'completed'>[],
  hasExtraData = false
): boolean {
  const meta = getStepShareMeta(stepNumber);
  const exclude = new Set<number>([
    meta.shareActionId,
    meta.finalActionId,
    ...(meta.secondaryShareActionIds || []),
  ]);
  const hasCompletedWork = actions.some((a) => a.completed && !exclude.has(a.id));
  return hasCompletedWork || hasExtraData;
}

/** Attach share button props to share action(s) in the actions list. */
export function withShareButton(
  stepNumber: number,
  actions: ActionItem[],
  openShareDialog: () => void
): ActionItem[] {
  const meta = getStepShareMeta(stepNumber);
  const shareIds = new Set([
    meta.shareActionId,
    ...(meta.secondaryShareActionIds || []),
  ]);
  const buttonText = meta.shareButtonText || getShareButtonText();
  return actions.map((a) =>
    shareIds.has(a.id)
      ? {
          ...a,
          hasButton: true,
          buttonText,
          buttonAction: openShareDialog,
        }
      : a
  );
}
